import { render, staticRenderFns } from "./CarePlanPage.vue?vue&type=template&id=a3d338c2"
import script from "./CarePlanPage.vue?vue&type=script&lang=js"
export * from "./CarePlanPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports